import { render, staticRenderFns } from "./SwitchList.vue?vue&type=template&id=ec3a4556&scoped=true"
import script from "./SwitchList.vue?vue&type=script&lang=js"
export * from "./SwitchList.vue?vue&type=script&lang=js"
import style0 from "./SwitchList.vue?vue&type=style&index=0&id=ec3a4556&prod&lang=scss"
import style1 from "./SwitchList.vue?vue&type=style&index=1&id=ec3a4556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3a4556",
  null
  
)

export default component.exports